import getActions from "./actionsPopupUtils";

const foreign_worker_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default foreign_worker_actions;
